import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../components/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

    constructor(private authService: AuthService, private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            const error = err.error.message || err.statusText;

            switch (err.status) {
                case 401:
                case 504:
                case 403:

                    this.authService.logout();
                    location.href = '/login';
                    return throwError(error);
                default:
                    this.toastr.error(error);
                    return throwError(error);
            }
        }))
    }
}
